import React from 'react'
import { useSelector } from 'react-redux'
import { selectSearchablePlatforms } from 'state/review'
import { PartiposterProfile, SocialMediaAccount } from 'state/submissions'
import { PlatformLinkRow } from 'components/Submissions/Review/PartiposterProfile'
import styled from 'particles/themes/styled'
import Text from 'particles/Text'

interface UserProfileProps {
    profileData: PartiposterProfile | undefined
    className?: string
}

const UserProfile: React.FC<UserProfileProps> = ({ profileData, className }) => {
    const searchablePlatforms = useSelector(selectSearchablePlatforms)

    const platformUsernames: string[] =
        searchablePlatforms && searchablePlatforms.length > 0
            ? searchablePlatforms.map(platform => {
                  const socialMediaAccounts = !!profileData?.social_media_accounts
                      ? Array.isArray(profileData?.social_media_accounts)
                          ? profileData?.social_media_accounts
                          : [profileData?.social_media_accounts]
                      : []
                  const account = socialMediaAccounts?.filter((account: SocialMediaAccount) => {
                      return account.platform === platform
                  })
                  return account?.[0]?.username ?? ''
              })
            : []
    if (profileData === undefined) {
        return <div />
    }
    return (
        <div className={className}>
            <img className="photo" src={profileData.photo} />
            <div>
                <Text scale="bodyM700">{profileData.name}</Text>
                {searchablePlatforms &&
                    searchablePlatforms.length > 0 &&
                    searchablePlatforms.map((platform, index) => {
                        if (index % 2 === 0) {
                            return (
                                <PlatformLinkRow
                                    key={`platform-link-${index}`}
                                    platforms={searchablePlatforms.slice(index)}
                                    usernames={platformUsernames.slice(index)}
                                />
                            )
                        } else {
                            return <></>
                        }
                    })}
            </div>
        </div>
    )
}

export default styled(UserProfile)`
    display: flex;
    gap: ${({ theme }) => theme.spacing[100]};
    align-items: center;
    .photo {
        width: 52px;
        height: 52px;
        border-radius: 2px;
    }
`
